exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--2BjMNTeSw3g5CbwbkuSFMo {\n  cursor: pointer;\n  line-height: 0;\n}\n", ""]);

// exports
exports.locals = {
	"actionButton": "care-team-tasks--2BjMNTeSw3g5CbwbkuSFMo",
	"actionButton": "care-team-tasks--2BjMNTeSw3g5CbwbkuSFMo"
};